export const inbox = {
  titles: {
    inbox: "Boîte de réception",
    unifiedInbox: "Votre boîte de réception, unifiée",
  },
  subtitles: {
    manageMessages: "Gérez les messages de vos canaux de réservation",
    unifiedDesc:
      "Vous verrez ici toutes les conversations avec vos voyageurs, qu'ils écrivent depuis Airbnb, Booking ou un autre canal.",
    subscribeHint:
      "Abonnez-vous pour activer votre boîte de réception et simplifier vos communications.",
    planOnly:
      "Ce module est uniquement disponible pour les forfaits {plans}.",
  },
  states: {
    notInstalledTitle: "Module de messages non installé",
    notInstalledDesc:
      "Installez le module de messagerie pour vous connecter à vos canaux de réservation.",
    noChannelsTitle: "Aucun canal connecté",
    noChannelsDesc:
      "Pour utiliser le module de messagerie, au moins un canal doit être connecté (Booking.com, Airbnb).",
    noAccessTitle: "Vous n'avez pas accès au module de messages",
  },
  actions: {
    installModule: "Installer le module de messages",
    configureChannel: "Configurer le canal",
  },
  toasts: {
    connectChannelRequiredTitle: "Connexion requise",
    connectChannelRequiredBody:
      "Connectez au moins un canal de réservation pour installer le module de messages.",
  },
  errors: {
    notFoundPropertyOrUser: "Propriété ou utilisateur introuvable.",
    channelConnectGeneric:
      "Erreur de connexion au canal. Veuillez réessayer.",
    generateTokenError: "Erreur lors de la génération du jeton",
  },
};
